import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
const optionalSwitch = z
    .boolean()
    .nullish()
    .transform((value) => value ?? undefined)
    .optional();
export const updateCustomerVolumeDiscountSettingsInputSchema = z
    .object({
    customerId: requiredUuidString('Customer is required.', 'Invalid customer selection.'),
    brandId: requiredUuidString('Brand is required.', 'Invalid brand selection.'),
    volumeDiscountsEnabled: optionalSwitch,
    volumeDiscountsOnSpecialPricing: optionalSwitch,
})
    .refine((input) => input.volumeDiscountsEnabled !== undefined ||
    input.volumeDiscountsOnSpecialPricing !== undefined, { message: 'Change at least one setting.' });
//# sourceMappingURL=update-customer-settings-input.js.map